__turbopack_context__.v({
  "root": "index-module__9O1VyG__root",
});
